//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"AdvancedVisViewTolerance",1,0],[0,"AdvancedVisViewUpdateMode",1,0],[0,"AlignAdvVisViewFacetsAlongEdges",1,0],[0,"AlignShadedViewFacetsAlongEdges",1,0],[0,"HiddenGeometryColor",1,0],[0,"ShadedViewTolerance",1,0],[0,"ShadedViewUpdateMode",1,0]],[[["shaded_view_tolerance_set","edge_tolerance","face_tolerance","angle_tolerance"],"GetShadedViewFacetTolerances",{},1,0],[["shaded_view_tolerance_set","edge_tolerance","face_tolerance","angle_tolerance"],"SetShadedViewFacetTolerances",{},4,0],[["adv_vis_view_tolerance_set","edge_tolerance","face_tolerance","angle_tolerance","width_tolerance"],"GetAdvVisViewFacetTolerances",{},1,0],[["adv_vis_view_tolerance_set","edge_tolerance","face_tolerance","angle_tolerance","width_tolerance"],"SetAdvVisViewFacetTolerances",{},5,0],[["updateEnvCube"],"RegenerateStudioAnalysisViewsFromToleranceChange",{},1,0],[[],"RegenerateShadedViewsFromToleranceChange",{},0,0]],[]];
SPLM.Preferences.PartVisualizationShade = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartVisualizationShade";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartVisualizationShade.ShadedViewToleranceType = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "Extrafine" : "Extrafine", "Ultrafine" : "Ultrafine", "Customize" : "Customize"});

SPLM.Preferences.PartVisualizationShade.AdvViewToleranceType = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "Extrafine" : "Extrafine", "Superfine" : "Superfine", "Ultrafine" : "Ultrafine", "Customize" : "Customize"});

SPLM.Preferences.PartVisualizationShade.ViewUpdateModeType = Object.freeze({
    "VisibleObject" : "VisibleObject", "VisibleFacesAndCurves" : "VisibleFacesAndCurves", "AllObject" : "AllObject", "None" : "None", "VisibleBodiesAndCurves" : "VisibleBodiesAndCurves"});

SPLM.Preferences.PartVisualizationShade.ShadedFaceEdge = Object.freeze({
    "Off" : "Off", "BodyColor" : "BodyColor", "SpecifyColor" : "SpecifyColor"});

SPLM.Preferences.PartVisualizationShade.HiddenShadedFaceEdges = Object.freeze({
    "Invisible" : "Invisible", "Dashed" : "Dashed", "HiddenColor" : "HiddenColor"});

export default SPLM;